const CurseResponse = () => {
  return (
    <div className="curse-box">
      <img src="/images/ralphie.jpg" alt="Take a break!" />
      <p className="curse">Time out!</p>
    </div>
  );
};

export default CurseResponse;
